type PlatformLocale = typeof import('../en/platform').default

const platform = {
	import: {
		enabled: 'Sistema de importación habilitado',
		defaultAuthMode: 'Modo de autenticación por defecto',
		logPayloads: 'Registrar payloads (depuración)',
		authMode: {
			session: 'Sesión',
			apiKey: 'Clave API',
			none: 'Ninguno',
		},
		rateLimit: {
			windowSeconds: 'Ventana de Límite (segundos)',
			max: 'Máximo de Solicitudes por Ventana',
		},
		endpoints: {
			pull: {
				enabled: 'Endpoint pull habilitado',
				authMode: 'Modo de autenticación',
			},
		},
	},
} satisfies PlatformLocale

export default platform
